import { render, staticRenderFns } from "./walletDialog.vue?vue&type=template&id=52dc7a3b&scoped=true"
import script from "./walletDialog.vue?vue&type=script&lang=js"
export * from "./walletDialog.vue?vue&type=script&lang=js"
import style0 from "./walletDialog.vue?vue&type=style&index=0&id=52dc7a3b&prod&lang=scss"
import style1 from "./walletDialog.vue?vue&type=style&index=1&id=52dc7a3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc7a3b",
  null
  
)

export default component.exports